import { SharpenFilter } from "../../../operations/filters/sharpen.js";
import { GLProgram } from "../../../program.js";
export class SharpenProgram extends GLProgram {

    constructor(gl: any, vertex_source: any, fragment_source: any) {
        super(gl, vertex_source, fragment_source);
    }

    static create(templates, gl) {
        var common_source = templates.get('photoshop/GL/shaders/common.glsl');
        var vertex_source = templates.get('photoshop/GL/shaders/filters/sharpen/vertex.glsl');
        var fragment_source = templates.get('photoshop/GL/shaders/filters/sharpen/fragment.glsl');
        var result = new SharpenProgram(gl, vertex_source, common_source + fragment_source);
        result._uniforms['texture'] = gl.getUniformLocation(result._program, 'u_texture');
        result._uniforms['texture_size'] = gl.getUniformLocation(result._program, 'u_texture_size');
        result._uniforms['radius'] = gl.getUniformLocation(result._program, 'u_radius');
        result._uniforms['gain'] = gl.getUniformLocation(result._program, 'u_gain');
        result._uniforms['use_selection'] = gl.getUniformLocation(result._program, 'u_use_selection');
        result._uniforms['selection_mask'] = gl.getUniformLocation(result._program, 'u_selection_mask');
        return result;
    }

    setUniforms(parameters: SharpenFilter) {
        var self = this;
        self._gl.uniform2f(self.uniformLocation('texture_size'), parameters._width, parameters._height);
        self._gl.uniform1f(self.uniformLocation('radius'), parameters.radius);
        self._gl.uniform1f(self.uniformLocation('gain'), parameters.gain / 250.0);
    }

}